import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Card, Table, Button, Modal, Form, Input, Select, Dropdown, Pagination } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { formatDate } from "../../util/helper";
import { isArrayNonEmpty } from "../../util/ApiHelper";
import ListEmptyComponent from "../../components/ListEmptyComponent/ListEmptyComponent";
import { useGetBreakpoints } from "../../hooks/useGetBreakpoints";
import Meta from "antd/lib/card/Meta";
import { getFreightRatesList } from "../../appRedux/actions/updatefreightrateAction";
import { CheckCircleFilled, CopyOutlined, DeleteOutlined, EditOutlined, ExclamationCircleFilled, EyeOutlined, FileTextOutlined, InfoCircleFilled, MoreOutlined, RocketOutlined, StarFilled } from "@ant-design/icons";
import { ItemDetailMobile } from "../../components/ItemDetailMobile";
import { axiosInstance, BASE_API_CONFIG } from "../../util/Api";
import { Tooltip } from 'antd'; // Add this import


const { Option } = Select;

 type RateLimitConfig = {
  RATE_LIMIT_FREE_PLAN: number;
  RATE_LIMIT_PAID_PLAN: number | null;
};

const UpdateFreightRateList = () => {
  const dispatch = useDispatch();
  const { isMobile } = useGetBreakpoints();
  const history = useHistory();
  const [form] = Form.useForm();
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [selectedRate, setSelectedRate] = useState(null);
  const [rateLimits, setRateLimits] = useState({
    free: undefined,
    paid: null,
  });

 console.log("rateLimits", rateLimits.free)

  const freightRatesList = useSelector((state) => state.freightRates.freightRatesList);
  const { loading } = useSelector(({ common }) => common);
  const authUser = useSelector(({ auth }) => auth.userData);
    console.log("authUser",authUser.id)

    const userFreightRates = freightRatesList.filter(item => item.userid === authUser?.id);
  const [subscriptionData, setSubscriptionData] = useState(null);

  const sortedFreightRates = userFreightRates
    .slice() 
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

   const [currentPage, setCurrentPage] = useState(1);
   const [pageSize, setPageSize] = useState(5);

  const paginatedData = useMemo(() => {
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    return userFreightRates.slice(startIndex, endIndex);
  }, [userFreightRates, currentPage, pageSize]);


    const ids = freightRatesList.map(item => item.userid);
    console.log("ids",ids)
  console.log("freightRatesList", freightRatesList); 



  const handleEditRate = useCallback((record) => {
    history.push({
      pathname: `/updatefreightrate/${record.id}`,
      state: { editData: record, isEdit: true }
    });
  }, [history]);


 useEffect(() => {
  const fetchLimits = async () => {
    try {
      const response = await axiosInstance.get('updates-freight-rates/freigh-rate-limit');
      setRateLimits({
        free: response.data.RATE_LIMIT_FREE_PLAN, // number
        paid: response.data.RATE_LIMIT_PAID_PLAN   // number | null
      });
    } catch (error) {
      console.error('Failed to fetch rate limits', error);
      // Keep as undefined to indicate fetch failure
    }
  };

  fetchLimits();
}, []);



  useEffect(() => {
    const fetchSubscription = async () => {
      try {
        const response = await axiosInstance.get(`${BASE_API_CONFIG.baseURL}/subscription-plans/user/${authUser?.id}`);
        setSubscriptionData(response.data);
      } catch (error) {
        console.error("Error fetching subscription:", error);
        setSubscriptionData({ planId: 1 }); // Default to free plan if error
      } 
    };
    
    if (authUser?.id) {
      fetchSubscription();
    }
  }, [authUser?.id]);

  useEffect(() => {
    dispatch(getFreightRatesList());
  }, [dispatch]);

  const handleCancelModal = () => {
    setShowUpdateModal(false);
    setSelectedRate(null);
    form.resetFields();
  };

  const showUpdateModalForRate = useCallback((rate) => {
    setShowUpdateModal(true);
    setSelectedRate(rate);
    form.setFieldsValue({
      rate: rate.rate,
      currency: rate.currency,
    });
  }, [form]);

  const isFreePlanActive = subscriptionData?.subscription?.planId === 1 && subscriptionData?.isActive === true;
const isPaidPlanActive = (subscriptionData?.subscription?.planId === 1 || subscriptionData?.subscription?.planId === 2 || subscriptionData?.subscription?.planId === 3) && subscriptionData?.isActive === true;
      console.log("isFreePlanActive",isFreePlanActive)
      console.log("isPaidPlanActive",isPaidPlanActive)

//   const getRateLimit = () => {
//   if (!subscriptionData) return 5;
//   if (isFreePlanActive) {
//     return 5; 
//   }
//   if (isPaidPlanActive) {
//     return null; 
//   }
//   return 0;
// };

const getRateLimit = () => {
    if (!rateLimits) return undefined; // Data not loaded yet
    
    if (!subscriptionData) return 0; // No subscription = no access
    if (isFreePlanActive) return rateLimits.free;
    console.log("isFreePlanActive", rateLimits.free)
    if (isPaidPlanActive) return rateLimits.paid;
    return 0;
  };

  const rateLimit = getRateLimit();
  const currentRateCount = userFreightRates.length;
  // Unlimited if rateLimit is null (planId 2 or 3)
  // const canCreateMoreRates = rateLimit === null || currentRateCount < rateLimit;
console.log("getRateLimit",rateLimit)
console.log("currentRateCount",currentRateCount)
// console.log("canCreateMoreRates",canCreateMoreRates)

const id =authUser.id;
const handleViewDetails = useCallback((record) => {
      history.push({
        pathname: `/freight-market-watch-Details/${id}`,
        state: { userFreightRates: record }, 
      });
    }, [history]);


  //    const renderMobileItem = (record) => (
  //   <ItemDetailMobile
  //     key={record.id}
  //     postedDate={formatDate(record.createdAt)}
  //     primaryRow={{
  //       text: `${record.loadingPort} to ${record.destinationPort}`,
  //       subText: record.destinationCountry,
  //     }}
  //     secondaryRow={{
  //       subText: `Valid until: ${formatDate(record.pricevalidity)}`,
  //     }}
  //     status={`${new Intl.NumberFormat('en-IN').format(record.oceanfreight)} ${record.currency}`}
  //     handleNavigation={() => handleViewDetails(record)}
  //   />
  // );



  const renderMobileItem = (record) => (
    <Card
    >
  <div 
    key={record.id}
    onClick={() => handleViewDetails(record)}
    style={{
      padding: "13px",
      borderBottom: "1px solid #f0f0f0",
      cursor: "pointer"
    }}
  >
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: "12px", color: "#666", marginBottom: "4px" }}>
          Posted on {formatDate(record.createdAt)}
        </div>
        <div style={{ 
          fontSize: "14px", 
          fontWeight: "bold", 
          marginBottom: "4px",
          color: "#333"
        }}>
          {record.loadingPort} To {record.destinationPort}
        </div>
        <div style={{ fontSize: "14px", color: "#666", marginBottom: "4px" }}>
          {record.destinationCountry}
        </div>
        <div style={{ fontSize: "12px", color: "#666" }}>
          Valid until: {formatDate(record.pricevalidity)}
        </div>
      </div>
      <div style={{ 
        fontSize: "16px", 
        fontWeight: "bold",
        color: "#1890ff",
        textAlign: "right"
      }}>
        {new Intl.NumberFormat('en-IN').format(record.oceanfreight)} {record.currency}
      </div>
    </div>
  </div>
  </Card> 
);

const renderMobileView = useCallback(
  () => (
    <div style={{ marginBottom: "16px" }}>
      {paginatedData.map((record) => (
        <React.Fragment key={record.id}>
          {renderMobileItem(record)}
        </React.Fragment>
      ))}
    </div>
  ),
  [paginatedData]
);
  

  const columns = useMemo(
    () => [
      {
            title: "Vessel ETD",
            key: "expectedDepartureDate",
            render: (record) => <div>{formatDate(record.expectedDepartureDate)}</div>,
      },
      {
            title: "Loading Port",
            key: "loadingPort",
            render: (record) => <div>{record.loadingPort}</div>,
      },
      {
        title: "Destination Port",
        key: "destinationPort",
        render: (record) => <div>{record.destinationPort}</div>,
      },
       {
        title: "Transmit Days",
        key: "transitDays",
        render: (record) => <div>{record.transitDays}</div>,
      },
      {
        title: "Ocean Freight",
        key: "oceanfreight",
         render: (_, record) => {
                const formattedFreight = new Intl.NumberFormat('en-IN', {
                  style: 'decimal',
                }).format(record.oceanfreight);
                return ` ${record.currency} ${formattedFreight}`;
              },
      },

// In your columns array, update the "Price Validity" column:
{
  title: "Price Validity",
  key: "pricevalidity",
  render: (record) => {
    const validityDate = new Date(record.pricevalidity);
    const today = new Date();
    const isExpired = validityDate < today;
    const isExpiringSoon = () => {
      const daysDifference = Math.ceil((validityDate - today) / (1000 * 60 * 60 * 24));
      return daysDifference <= 3 && daysDifference >= 0;
    };

    // Determine status and tooltip message
    let statusColor = 'inherit';
    let statusMessage = '';
    let icon = null;

    if (isExpired) {
      statusColor = '#ff4d4f';
      statusMessage = 'This rate has expired';
      icon = <ExclamationCircleFilled style={{ color: '#ff4d4f', fontSize: '14px' }} />;
    } else if (isExpiringSoon()) {
      statusColor = '#faad14';
      const daysLeft = Math.ceil((validityDate - today) / (1000 * 60 * 60 * 24));
      statusMessage = `Expires in ${daysLeft} day${daysLeft > 1 ? 's' : ''}`;
      icon = <ExclamationCircleFilled style={{ color: '#faad14', fontSize: '14px' }} />;
    } else {
      const daysLeft = Math.ceil((validityDate - today) / (1000 * 60 * 60 * 24));
      statusMessage = `Valid for ${daysLeft} more day${daysLeft > 1 ? 's' : ''}`;
    }

    return (
      <Tooltip 
        title={statusMessage}
        placement="top"
        color={isExpired ? '#ff4d4f' : isExpiringSoon() ? '#faad14' : '#1677ff'}
      >
        <div style={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: 4,
          color: statusColor,
          // cursor: 'help' // Shows a help cursor on hover
        }}>
          {formatDate(record.pricevalidity)}
          {icon}
        </div>
      </Tooltip>
    );
  },
},
      {
  title: "Actions",
  key: "actions",
  render: (record) => (
    <div
      className="myexim-action-icon"
      onClick={(e) => e.stopPropagation()}
    >
      <Dropdown
        menu={{
          items: [
            {
              label: "View Details",
              key: "1",
              icon: <EyeOutlined />,
              onClick: () => {
                handleViewDetails(record);
              },
            },
            {
              label: "Edit",
              key: "2",
              icon: <EditOutlined />,
              onClick: () => {
                handleEditRate(record);
              },
            },
          ],
        }}
        trigger={["click"]}
      >
        <MoreOutlined />
      </Dropdown>
    </div>
  ),
},
    ],
    [showUpdateModalForRate]
  );

  // const renderMobileView = useCallback(
  //   () =>
  //     sortedFreightRates.map((freightRatesList,index) => (
  //       <React.Fragment key={freightRatesList.key}>
  //         <div style={{ display: "flex", alignItems: "center",marginBottom: "16px",marginTop:"-5px",marginLeft:"1px" }}>
  //           <div style={{ flex: 1 }} onClick={() => handleViewDetails(freightRatesList)}>
  //             <div style={{ fontSize: "12px", color: "#666", marginBottom: "8px" }}>
  //               Posted On {formatDate(freightRatesList.createdAt)}
  //             </div>
  //               <div
  //               style={{
  //                 fontSize: "16px",
  //                 fontWeight: "bold",
  //                 marginBottom: "4px",
  //                 color: "#333",
  //               }}
  //             >
  //               {freightRatesList.destinationCountry}
  //             </div>
  
  //             <div style={{ fontSize: "14px", color: "#666", marginBottom: "14px" }}>
  //               {freightRatesList.destinationPort}
  //             </div>
  //           </div>
  //             <div style={{ marginRight: "30px" ,fontWeight: "bold"}}>
  //           {freightRatesList.oceanfreight} {freightRatesList.currency}
        
  //           </div>
  //         </div>
  //         {index !== sortedFreightRates.length - 1 && <hr style={{ margin: "16px 0" }} />}
  //         </React.Fragment>
  //               )),
  //   [paginatedData, showUpdateModalForRate]
  // );


  const handleCreateClick = () => {

   
  // if (subscriptionData?.isActive || canCreateMoreRates) {
  //   Modal.confirm({
  //     title: (
  //       <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
  //         <ExclamationCircleFilled style={{ color: '#faad14', fontSize: 20 }} />
  //         <span>Freight Rate Limit Reached</span>
  //       </div>
  //     ),
  //     icon: null, // We're customizing the title instead
  //     width: 500,
  //     centered: true,
  //     content: (
  //       <div style={{ padding: '14px 0' }}>
  //         <div style={{ 
  //           display: 'flex', 
  //           alignItems: 'center', 
  //           gap: 12,
  //           padding: '12px 16px',
  //           backgroundColor: '#fffbe6',
  //           borderRadius: 8,
  //           marginBottom: 12
  //         }}>
  //           <InfoCircleFilled style={{ color: '#faad14', fontSize: 18 }} />
  //           <div>
  //             <p style={{ margin: 0, fontWeight: 500 }}>You've reached your free tier limit</p>
  //             <p style={{ margin: '4px 0 0 0', color: '#666' }}>
  //               {currentRateCount}/{rateLimit} freight rates used
  //             </p>
  //           </div>
  //         </div>
          
  //         <div style={{ marginBottom: 20 }}>
  //           <h4 style={{ marginBottom: 8 }}>Upgrade Benefits:</h4>
  //           <ul style={{ 
  //             margin: 0, 
  //             paddingLeft: 20,
  //             listStyleType: 'none'
  //           }}>
  //             <li style={{ marginBottom: 8, display: 'flex', alignItems: 'flex-start' }}>
  //               <CheckCircleFilled style={{ color: '#52c41a', marginRight: 8, marginTop: 4 }} />
  //               <span>Unlimited freight rate creation</span>
  //             </li>
  //             <li style={{ marginBottom: 8, display: 'flex', alignItems: 'flex-start' }}>
  //               <CheckCircleFilled style={{ color: '#52c41a', marginRight: 8, marginTop: 4 }} />
  //               <span>Priority listing in freight marketplace</span>
  //             </li>
  //             <li style={{ display: 'flex', alignItems: 'flex-start' }}>
  //               <CheckCircleFilled style={{ color: '#52c41a', marginRight: 8, marginTop: 4 }} />
  //               <span>Advanced analytics dashboard</span>
  //             </li>
  //           </ul>
  //         </div>
          
  //         <div style={{ 
  //           backgroundColor: '#f6ffed',
  //           border: '1px solid #b7eb8f',
  //           borderRadius: 8,
  //           padding: 12
  //         }}>
  //           <p style={{ margin: 0, display: 'flex', alignItems: 'center' }}>
  //             <StarFilled style={{ color: '#faad14', marginRight: 8 }} />
  //             <span>Premium members get 2x more leads on average</span>
  //           </p>
  //         </div>
  //       </div>
  //     ),
  //     okText: (
  //       <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
  //         <RocketOutlined />
  //         Upgrade Plan
  //       </span>
  //     ),
  //     cancelText: "Maybe Later",
  //     okButtonProps: {
  //       style: { background: '#1890ff', borderColor: '#1890ff' }
  //     },
  //     onOk: () => history.push("/subscription-User"),
  //   });
  //   return;
  // }
  history.push("/updatefreightrate");
};

  const handlePageChange = (page, newPageSize) => {
    setCurrentPage(page);
    if (newPageSize !== pageSize) {
      setPageSize(newPageSize);
      setCurrentPage(1);
    }
  };

 const renderContent = useCallback(
  (data, count) => {
    return isMobile ? (
      <div>
        {renderMobileView()}
        <Pagination
          current={currentPage}
          pageSize={pageSize}
          total={userFreightRates.length}
          onChange={handlePageChange}
          showSizeChanger={true}
          showQuickJumper={false}
          simple
          style={{ marginTop: 16, textAlign: "center" }}
        />
      </div>
    ) : (
      <Table
        rowClassName={(record, index) =>
          index % 2 === 0 ? "table-row-light" : "table-row-dark"
        }
        className="gx-table-responsive rfq-table myexim-table"
        columns={columns}
        onRow={(record) => ({
          onClick: () => handleViewDetails(record),
        })}
        dataSource={data}
        pagination={{
          position: ["bottomRight"],
          showSizeChanger: true,
          pageSize: 5,
          total: count,
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} of ${total} items`,
        }}
      />
    );
  },
  [columns, isMobile, renderMobileView, currentPage, pageSize, userFreightRates.length]
);
  const { Meta } = Card;
   const description = `Instant Freight Rates updated here will be displayed to the
                Exporters who are doing business to respective Loading Ports and
                Destination Ports.`;

  return (
    
    <>
      <Card
  title={
    <div>
      <div style={isMobile ? {} : { display: "flex", alignItems: "center" }}>
        <div className="myexim-table-title">Update Freight Rates</div>
        {!isMobile && (
          <Button
            type="primary"
            onClick={handleCreateClick}
            style={{ marginLeft: 15 }}
          >
            + Create New Freight Rate
          </Button>
        )}
      </div>

 {isMobile && (
    <Button
      type="primary"
      onClick={handleCreateClick}
      style={{ marginTop: 16, width: '100%' }}
      block
    >
      + Create New Freight Rate
    </Button>
  )}


    </div>
  }
  style={{ width: "100%" }}
>
   <Meta
    description={
      <div style={{ lineHeight: 1.5 }}>
        <span style={{ color: "#1677ff" }}>{description}</span>
      </div>
    }
  />
</Card>
      {isArrayNonEmpty(sortedFreightRates)
          ? renderContent(sortedFreightRates, sortedFreightRates.length)
          : !loading && (
              <ListEmptyComponent message="No Freight Rates Created Yet, Try it now" />
            )}

            
    </>
  );
};

export default UpdateFreightRateList;
